<template>
  <PreviewVector />
</template>

<script>
import { validatePreviewId } from '~/utils/common.js';
import PreviewVector from '@/components/Preview/PreviewVector';

export default {
  nuxtI18n: {
    paths: {
      en: '/editables/preview/:id/:name',
      de: '/editables/preview/:id/:name',
      es: '/editables/vista-previa/:id/:name',
      pt: '/editables/previsualizar/:id/:name'
    }
  },
  components: {
    PreviewVector
  },
  async validate({ store, app: { $urlBuilder }, params, route, redirect }) {
    await store.dispatch('vectors/LOAD_VECTOR_DATA', params.id);
    let actualVector = store.state.vectors.actualVector;
    return validatePreviewId(actualVector, route.path, $urlBuilder, redirect);
  },
  async asyncData({ store, $urlBuilder, $openGraphPlugin }) {
    const { en, es, pt, de } = store.state.vectors.actualVector.metadata.alternateLanguages;
    const { metaTitle, metaDescription } = store.state.vectors.actualVector.metadata;
    const { openGraph } = store.state.vectors.actualVector.metadata;
    const url = $urlBuilder('preview', {
      id: store.state.vectors.actualVector.id,
      canonizedName: store.state.vectors.actualVector.slug,
      type: store.state.vectors.actualVector.idType
    });

    let openGraphData = $openGraphPlugin(
      openGraph.ogMetaTitle,
      openGraph.ogMetaType,
      url,
      openGraph.ogMetaDescription,
      openGraph.ogMetaImage,
      store.state.i18n.locale
    );
    const params = {
      en: { name: en },
      es: { name: es },
      pt: { name: pt },
      de: { name: de }
    };
    store.dispatch('i18n/setRouteParams', params);
    return { metaTitle, metaDescription, openGraphData };
  },
  head() {
    return {
      title: this.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDescription
        },
        ...this.openGraphData
      ]
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch('vectors/LOAD_VECTOR_RELATEDS', this.$route.params.id);
    } catch (error) {
      console.error('Error loading related vectors: ', error);
    }
  }
};
</script>
